import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useAtom } from 'jotai';
import { Cookies, Header, ClearCookies, EmptyList } from 'Components/Common';
import {
  cookiesAtom,
  displayClearCookiesAtom,
  staticDataAtom,
  listTicketsAtom,
} from 'Atoms/Common';
import AllTickets from '../AllTickets';
import { Transition } from 'react-transition-group';

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.containerGrid,
    // backgroundColor: '#efeff4',
    height: '100%',
    margin: 'auto !important',
    //paddingTop: '1rem',
  },
  subHeader: {
    margin: '1rem',
  },
  important: {
    fontWeight: 'bold',
  },
  title: theme.subTitle,
  subTitle2: { ...theme.subTitle2, marginLeft: '1rem' },
  otherActions: {
    marginBottom: '9rem',
  },
  blur: {
    filter: 'blur(4px)',
  },
  '& display-enter': {
    opacity: 0,
    transform: 'translateY(-100%)',
  },
  '& display-enter-active': {
    opacity: 1,
    transform: 'translateY(100%)',
    transition: 'all 800ms',
  },
  '& display-exit': {
    opacity: 1,
    transform: 'translateY(100%)',
  },
  '& display-exit-active': {
    opacity: 0,
    transform: 'translateY(-100%)',
    transition: 'all 500ms',
  },
}));

const HomePage = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [cookies, setCookies] = useAtom(cookiesAtom);
  const [displayClearCookies, setDisplayClearCookies] = useAtom(
    displayClearCookiesAtom,
  );
  const [staticData, setStaticData] = useAtom(staticDataAtom);
  const [list] = useAtom(listTicketsAtom);
  const askCookies = staticData?.askCookies;

  const handleClickAway = (e) => {
    e.preventDefault();
    setDisplayClearCookies(false);
  };

  useEffect(() => {
    if (!staticData?.idSession) {
      // initData();
    }
  }, []);
  useEffect(() => {
    if (!!askCookies) {
      return setCookies(true);
    }
    if (!askCookies && !cookies) {
      return setCookies(true);
    }
  }, []);

  /* const initData = async () => {
     const pathname = window?.location?.pathname;
     const ticketAlias = getTicketAliasFromPathname(pathname);
     const staticTicketData = await getStaticData(ticketAlias, staticData);
     setStaticData(staticTicketData);
   }; */

  return (
    <>
      <Header
        title={staticData?.company?.name}
        actions={
          cookies
            ? {
                prev: {
                  icon: 'laddition',
                  path: '/',
                  label: '',
                },
                next: {
                  icon: cookies && list && 'trash',
                  path: '',
                  label: '',
                  action: cookies && list && 'clearCookies',
                },
              }
            : {}
        }
      />

      <Grid
        container
        className={classes.root}
        onClick={(e) => handleClickAway(e)}
      >
        {cookies && (!list || list.length === 0) && (
          <Grid
            container
            className={` ${displayClearCookies && classes.blur} `}
          >
            <EmptyList label="empty_ticket" />
          </Grid>
        )}
        {cookies && list?.length > 0 && (
          <Grid container className={`${displayClearCookies && classes.blur}`}>
            <AllTickets list={list} />
          </Grid>
        )}
        <Transition
          in={displayClearCookies}
          timeout={150}
          classNames="display"
          unmountOnExit
        >
          <ClearCookies />
        </Transition>
        {!!askCookies && !cookies && <Cookies />}
      </Grid>
    </>
  );
};

HomePage.propTypes = {};

export default HomePage;
